import { ErrorBoundary } from 'react-error-boundary';
import circleExclamationIcon from '../../images/circle-exclamation-solid.png';
import reloadIcon from '../../images/rotate-right-solid.png';
import Messages from './Messages';

function ErrorFallback ({error, resetErrorBoundary}) {
    return (
        <div className="container-lg">
            <div className="border border-light-subtle border-2 rounded-3 my-5 mx-auto p-3 p-sm-4" style={{maxWidth: "700px"}}>
                <div className="row gap-3">
                    <div className="col-sm-10 offset-sm-1 text-center">
                        <div className="h5 m-0">Something went wrong</div>
                    </div>
                    <div className="col-12 text-center">
                        <img src={circleExclamationIcon} alt="Alert" title="Alert" style={{width: "31px"}}></img>
                    </div>
                    <div className="col-sm-10 offset-sm-1 text-center">
                        {Messages.ErrorGeneric}
                        {/* {error.message ? error.message : Messages.ErrorGeneric} */} {/* Developement Errors */}
                    </div>
                    <div className="col-12 text-center">
                        <button type="button" className="btn btn-dark rounded-pill px-5" onClick={resetErrorBoundary} >
                            <div className="d-flex align-items-center">
                                <span>Reload&ensp;</span>
                                <img src={reloadIcon} alt="Refresh" title="Refresh" style={{width: "16px"}}></img>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function ErrorBoundaryComponent({ children }) {
    return(
        <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => window.location.reload()}>   
            {children}         
        </ErrorBoundary>
    )
}